// List of properties
var types = require("./types");
var _        = require('underscore');


var MetaProperties = {};


/////////////////////////////////////
///
//              Property Definitions
//////////

MetaProperties["footprint"] = {
    "ipcFamily": {
        displayTitle: 'IPC Family',
        serverName: 'ipc_family',
        description: 'The IPC package family name.',
        enums: {
            BGA:      {key:"BGA",         val: 0 },
            CFP:      {key:"CFP",         val: 1 },
            CQFP:     {key:"CQFP",        val: 2 },
            CHIP:     {key:"Chip",        val: 3 },
            CHIPARR:  {key:"Chip Array",  val: 4 },
            CRYSTAL:  {key:"Crystal",     val: 5 },
            DFN:      {key:"DFN",         val: 6 },
            ECAP:     {key:"E-Cap",       val: 7 },
            MELF:     {key:"MELF",        val: 8 },
            MOLDED:   {key:"Molded Body", val: 9 },
            OSCIL:    {key:"Oscillator",  val: 10},
            PLCC:     {key:"PLCC",        val: 11},
            QFN:      {key:"QFN",         val: 12},
            QFP:      {key:"QFP",         val: 13},
            SOD:      {key:"SOD",         val: 14},
            SODFL:    {key:"SODFL",       val: 15},
            SOIC:     {key:"SOIC, SOP",   val: 16},
            SOJ:      {key:"SOJ",         val: 17},
            SOT143:   {key:"SOT143",      val: 18},
            SOT223:   {key:"SOT223",      val: 19},
            SOT23:    {key:"SOT23",       val: 20},
            SOTFL:    {key:"SOTFL",       val: 21},
            DPAK:     {key:"TO, DPAK",    val: 22},
            AXIAL:    {key:"Axial",       val: 23},
            DIP:      {key:"DIP",         val: 24},
            HEADER:   {key:"HEADER",      val: 25},
            SON:      {key:"SON",         val: 26},
            RADIAL:   {key:"Radial",      val: 27},
            CHIPLED:  {key: "Chip LED",   val: 28},
            SNAPLOCK: {key: "Snap Lock",  val: 29},
            STANDOFF: {key: "Standoff, Spacer", val: 30}
        },
        group: 'identity'
    },

    "ipcName": {
        displayTitle: 'IPC Name',
        serverName: 'ipc_name',
        description: 'IPC standard name (e.g., SOIC127P1030X265-14).  For footprints, include L/M/N suffix (density).',
        defaultText: '',
        type: types.string,
        group: 'identity'
    },

    "jedecFamily": {
        displayTitle: 'JEDEC Family',
        serverName: 'jedec_family',
        description: 'The JEDEC standard name. (e.g., MO-220)',
        defaultText: '',
        type: types.string,
        group: 'identity'
    },

    "jedecVariant": {
        displayTitle: 'JEDEC Variant',
        serverName: 'jedec_variant',
        description: 'The particular variant of the JEDEC family. (e.g., AA, AB)',
        defaultText: '',
        type: types.string,
        group: 'identity'
    },

    "pins": {
        displayTitle: 'Pins',
        serverName: 'pins',
        description: 'The number of pins in the package. (e.g., 4)',
        defaultText: '',
        type: types.positive_int,
        group: 'dimensions'
    },

    "pitch": {
        displayTitle: 'Pitch',
        serverName: 'pitch',
        description: 'Center to center pin spacing of the package. (e.g., 1.27mm, 0.13cm)',
        defaultText: '',
        type: types.positive_float,
        unit: "mm",
        storageUnit: "um",
        group: 'dimensions'
    },

    "pitch2": {
        displayTitle: 'Pitch 2',
        serverName: 'pitch2',
        description: 'Center to center pin spacing of secondary side (rarely used).  (e.g., 1.27mm, 0.13cm)',
        defaultText: '',
        type: types.positive_float,
        unit: "mm",
        storageUnit: "um",
        group: 'dimensions'
    },

    "bodyLength": {
        displayTitle: 'Body Length',
        serverName: 'body_length',
        description: 'The length of the package body (length generally increases with pin count). Nominal value.  (e.g., 1.5mm, 0.15cm)',
        defaultText: '',
        type: types.positive_float,
        unit: "mm",
        storageUnit: "um",
        group: 'dimensions'
    },

    "bodyWidth": {
        displayTitle: 'Body Width',
        serverName: 'body_width',
        description: 'The width of the package body. Nominal value. (e.g., 1.5mm, 0.15cm)',
        defaultText: '',
        type: types.positive_float,
        unit: "mm",
        storageUnit: "um",
        group: 'dimensions'
    },

    "height": {
        displayTitle: 'Height',
        serverName: 'height',
        description: 'Overall height of the package from the surface of the board to the top of the component body. Maximum value. (e.g. 0.5mm, 19.6mil)',
        defaultText: '',
        type: types.positive_float,
        unit: "mm",
        storageUnit: "um",
        group: 'dimensions'
    },

    "leadSpan": {
        displayTitle: 'Lead Span',
        serverName: 'lead_span',
        description: 'Tip to Tip distance between terminals across the body of the footprint. Nominal value. (e.g., 1.25mm, 0.13cm)',
        defaultText: '',
        type: types.positive_float,
        unit: "mm",
        storageUnit: "um",
        group: 'dimensions'
    },

    "leadSpan2": {
        displayTitle: 'Lead Span 2',
        serverName: 'lead_span2',
        description: 'Tip to tip distance between terminals across the body of the footprint along secondary side. Nominal value. (e.g., 20mm, 0.79in)',
        defaultText: '',
        type: types.positive_float,
        unit: "mm",
        storageUnit: "um",
        group: 'dimensions'
    },

    "mountingType": {
        displayTitle: 'Mounting Type',
        serverName: 'mounting_type',
        description: 'Surface mount or through-hole technology.',
        enums: {
            SMD:      {key:"Surface Mount",  val:0},
            PTH:      {key:"Through Hole",   val:1},
            COMBO:    {key:"Combination",    val:2}
        },
        group: 'defaults'
    }
}


// packages and footprints have identical metaData.
MetaProperties["package"] = MetaProperties["footprint"];


//////////////////////////////////////  Helper Functions

// get an enum object from its string (untested)
MetaProperties.getEnumFromNumber = function(dataTypeStr, propertyTypeStr, number){
    var enums = MetaProperties[dataTypeStr][propertyTypeStr].enums;
    var obj = null;
     var found = false;
    _.each(enums, function(currEnum){
        if(found) return;
        if(currEnum.val == number){
            obj = currEnum;
            found = true;
        }
    });
    return obj;
};

// get an enum object from its value (untested)
MetaProperties.getEnumFromString = function(dataTypeStr, propertyTypeStr, str){
    var enums = MetaProperties[dataTypeStr][propertyTypeStr].enums;
    var obj = null;
    var found = false;
    _.each(enums, function(currEnum){
        if(found) return;
        if(currEnum.key == str){
            obj = currEnum;
            found = true;
        }
    });
    return obj;
};

// get a property object from its server name (untested)
MetaProperties.getPropertyFromServerName = function(dataTypeStr, serverName){
    var enums = MetaProperties[dataTypeStr];
    var obj = null;
    var found = false;
    _.each(enums, function(currProp){
        if(found) return;
        if(currProp.serverName == serverName){
            obj = currProp;
            found = true;
        }
    });
    return obj;
};

// get a property object from its server name (untested)
MetaProperties.getPropertyKeyFromServerName = function(dataTypeStr, serverName){
    var enums = MetaProperties[dataTypeStr];
    var key = null;
    var found = false;
    _.each(enums, function(currProp, currKey){
        if(found) return;
        if(currProp.serverName == serverName){
            key = currKey;
            found = true;
        }
    });
    return key;
};

module.exports = MetaProperties;
